// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rIYB7d4h0dqIsC {
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px) var(--ds-space-075, 6px) var(--ds-space-100, 8px);
  background-color: var(--ds-background-accent-blue-bolder, #0c66e4);
  color: var(--ds-text-inverse, #ffffff);
  font-weight: var(--ds-font-weight-regular, 300);
  gap: var(--ds-space-050, 4px);
}
.rIYB7d4h0dqIsC.vALStXQMYGJgVg {
  background: linear-gradient(79.47deg, var(--ds-background-accent-purple-bolder, #6e5dc6) 25.62%, var(--ds-background-accent-blue-bolder, #0c66e4) 99.57%);
}
.rIYB7d4h0dqIsC:hover {
  background-color: var(--ds-background-accent-blue-bolder-hovered, #0055cc);
  color: var(--ds-text-inverse, #ffffff);
}
.AIZZzzaOHs3KrP {
  width: 24px;
  height: 24px;
}
`, ""]);
// Exports
export var upgradePromptButton = `rIYB7d4h0dqIsC`;
export var gradientBackground = `vALStXQMYGJgVg`;
export var upgradePromptButtonIcon = `AIZZzzaOHs3KrP`;
export default ___CSS_LOADER_EXPORT___;
